import { isNumber } from "lodash"

// Format number using `toLocaleString()`. Return `fallback`
// when `number` is undefined or not a number.
export const formatNumberLocale = (number, fallback = "") => {
  return isNumber(number) ? number.toLocaleString() : fallback
}
